export default __webpack_public_path__ + "static/media/king-on-africa.46bb0121.jpg";